module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/carTypeIcon.svg?e5f394ca";